// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12O52","left":"styles_left__DdXOA","desktopActions":"styles_desktopActions__1LlPu","title":"styles_title__3M_XZ"};